import React from 'react';
import {LoadingCircle} from 'src/shared/components/LoadingCircle';
import {loading} from './styles.module.scss';

export const ChannelsLoading = () =>
  <>
    <LoadingCircle className={loading} />
    <p className={loading}>hang on, we are getting that for you...</p>
  </>;
